<template>
  <v-app class="J-body">
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import { EventBus } from './helpers/eventbus/event-bus'

import initVue from './helpers/initVue'

import {
    mapGetters,
    mapActions
} from 'vuex'


export default {
  name: 'App',
  computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
  }),
  data () {
    return {
      n:1,
      isHome:false,
      identity: null,
      session: false,
      token: null,
      chatdesktophidden: false,
      chatcontaineropen: false,
      userstorage: {}
    }
  },

  components:{
        
    },
  
  mounted(){
    this.getidentity()
    this.getuser()
    if(screen.width > 1000 && this.session === true) {
      this.chatdesktophidden = false
    }
    
  },

  methods:{
    getuser(){
      if(this.session){
          this.axios.get(`users/getuser`)
          .then((res) => {

              this.userstorage = res.data.user
              
          })
          .catch((err) => {
              
          })
      }
    },
    /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
    getidentity(){
        this.identity = initVue.getIdentity().identity
        this.token = initVue.getIdentity().token
        this.session = initVue.isLogged(this.identity, this.token)
    },
    openchatcontainer(){
      let closechat = false
      let openingchatcontainer = this.chatdesktophidden === true && closechat === false
      if(openingchatcontainer){
        this.chatcontaineropen = true
      }
    },

    closechatcontainer(){
      let closechat = true
      let closingchatcontainer = this.chatdesktophidden === true && closechat
      if(closingchatcontainer){
        this.chatcontaineropen = false
      }
    }
  }
}
</script>
